/**
 * Minimal pub/sub so `apiClient.ts` (a plain module, no React) can notify
 * `AuthContext` (React state) that the session is no longer valid - e.g.
 * after a background refresh attempt fails - without either module
 * importing the other.
 */

type Listener = () => void;

const sessionExpiredListeners = new Set<Listener>();

export const authEvents = {
  onSessionExpired(listener: Listener): () => void {
    sessionExpiredListeners.add(listener);
    return () => sessionExpiredListeners.delete(listener);
  },

  emitSessionExpired(): void {
    for (const listener of sessionExpiredListeners) {
      listener();
    }
  },
};
